import { Schema } from 'further-types/investor';

export const signUpSourceLabel: Record<Schema.SignUpSource, string> = {
  [Schema.SignUpSource.Upload]: 'Upload',
  [Schema.SignUpSource.Adviser]: 'Adviser',
  [Schema.SignUpSource.SelfSignup]: 'Self signup',
  [Schema.SignUpSource.CloneFromExistingInvestor]: 'Self signup (clone)',
  [Schema.SignUpSource.AddSingleInvestor]: 'Add investor page',
};
